// AUTO-GENERATED by scripts/generate-blog.js — do not edit.
export const hasEnPosts = false;
export const hasPtPosts = false;
